<template>
  <material-card
    :title="`${ $t('Sales') }`"
    color="dover-blue">
    <v-form
      ref="form"
      v-model="isValidationOk"
      lazy-validation>
      <v-container
        py-0
        fill-height
        fluid
        grid-list-xl>
        <v-layout
          wrap>
          <v-flex
            xs12
            md4>
            <MaglinkComponentTankList
              :loading="progressBar.loading"
              :filters="filters"
              :tanks="tanks" />
          </v-flex>
          <v-flex
            xs12
            md2>
            <v-switch
              :disabled="progressBar.loading"
              v-model="filters.all"
              :label="`${ $t('All tanks') }`"
              class="dover-input"/>
          </v-flex>
          <v-flex
            xs12
            md2>
            <MaglinkComponentDatePicker
              :component-key="1"
              :rules-is-date="rules.isDate"
              :initial-date="dateFromToday(0)"
              :date-label="getDateLabel('For')"
              :date-format="systemSettings.dateFormat"
              :loading="progressBar.loading"
              :clear-date="false"
              @getDate="onGetDate"
              @checkDates="onCheckDates"/>
          </v-flex>
          <v-flex
            xs6
            md2
            text-xs-left>
            <v-btn
              :disabled="!isValidationOk || progressBar.loading"
              small
              class="mx-0 font-weight-light"
              color="dover-blue"
              @click="applyFilter">
              {{ $t('Load') }}
            </v-btn>
          </v-flex>
          <v-flex
            xs6
            md2
            text-xs-right>
            <MaglinkComponentCsvExportButton
              :is-validation-ok="isValidationOk"
              :loading="progressBar.loading"
              @csvExport="csvExport" />
          </v-flex>
          <v-flex
            xs12
            md12
            lg12>
            <MaglinkComponentLoadingBar
              :loading="progressBar.loading"
              :indeterminate="false"
              :max-value="progressBar.maxValue"
              :value="progressBar.currentValue" />
            <span>{{ itemCountLabel }}</span>
            <hr>
          </v-flex>
          <v-flex
            xs12
            md12
            lg12>
            <v-data-table
              :headers="headers"
              :items="dataSource"
              :no-data-text="`${ Maglink.NoDataMessage(false) }`"
              :no-results-text="`${ Maglink.NoDataMessage(true) }`"
              hide-actions>
              <template
                slot="headerCell"
                slot-scope="{ header }">
                <span
                  class="dover-light-blue-color"
                  v-text="header.text" />
              </template>
              <template
                slot="items"
                slot-scope="{ index, item }">
                <tr
                  :style="{backgroundColor: ((index % 2 === 0) ? '#cfdbfb' : 'transparent' ) }"
                  class="text-xs-left">
                  <td class="text-xs-center">{{ getTankList(item.fuelingPosition, item.meterID) }}</td>
                  <td class="text-xs-center">{{ item.fuelingPosition }}</td>
                  <td class="text-xs-center">{{ item.meterID }}</td>
                  <td>{{ getTime(item.timeB) }}</td>
                  <td>{{ getTime(item.timeC) }}</td>
                  <td class="text-xs-right">{{ Maglink.GetMinuteSecondFormat(item.timeB, item.timeC) }}</td>
                  <td class="text-xs-right">{{ Maglink.VolumeFormat(item.transactionVolume, systemSettings.volumeUnit) }}</td>
                  <td class="text-xs-center">
                    <img
                      :src="Maglink.GetImageAlarm(item.complete ? 0 : 1)"
                      width="10px">
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </v-container>
    </v-form>
  </material-card>
</template>

<script>
export default {
  props: {
    tanks: {
      type: Array,
      required: true,
      default: () => []
    },
    systemSettings: {
      type: Object,
      required: true,
      default: () => {}
    },
    options: {
      type: Object,
      required: true,
      default: () => {}
    },
    siteInfo: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  data: () => ({
    progressBar: {
      loading: false,
      maxValue: 100,
      currentValue: 0
    },
    isValidationOk: false,
    headers: [],
    rules: {
      isDate: [ v => true ]
    },
    siteMapping: {},
    dispenserList: {},
    itemCountLabel: '',
    dataSource: [],
    filters: {
      all: false,
      number: 1,
      fromDay: ''
    },
    volUdm: ''
  }),
  mounted () {
    this.Maglink.GetSiteMapping()
      .then(response => {
        this.siteMapping = response.data
        this.loadDispenserList()
      }).catch(error => (this.snack('error', error.message)))

    var currentDate = new Date()
    this.filters.fromDay = currentDate.toISOString().substr(0, 10)

    this.volUdm = this.options.volumeUnits[this.systemSettings.volumeUnit || 0].desc

    this.headers = [
      { sortable: false, text: this.$t('Tank'), align: 'left' },
      { sortable: false, text: this.$t('Dispenser'), align: 'center' },
      { sortable: false, text: this.$t('Nozzle'), align: 'center' },
      { sortable: false, text: this.$t('Started'), align: 'left' },
      { sortable: false, text: this.$t('Ended'), align: 'left' },
      { sortable: false, text: this.$t('Duration'), align: 'center' }, // { sortable: false, text: this.$t('Duration ({0})', [ this.$t('sec') ]), align: 'center' },
      { sortable: false, text: this.$t('Sales') + ' (' + this.volUdm + ')', align: 'right' },
      { sortable: false, text: this.$t('Complete'), align: 'center' }
    ]
  },
  methods: {
    applyFilter () {
      this.getDataSource()
    },
    csvExport (sep) {
      let fileContent = ''
      let title = ''

      if (this.siteInfo.name) {
        fileContent += this.siteInfo.name + '\n'
      }
      if (this.siteInfo.header1) {
        fileContent += this.siteInfo.header1 + '\n'
      }
      if (this.siteInfo.header2) {
        fileContent += this.siteInfo.header2 + '\n'
      }
      if (this.siteInfo.header3) {
        fileContent += this.siteInfo.header3 + '\n'
      }

      // filter
      if (this.filters.all) {
        title = this.$t('All tanks')
        fileContent += title + '\n'
      } else {
        title = this.$t('Tank {0}', [ this.filters.number ])
        fileContent += title + sep
        fileContent += this.tanks[this.filters.number - 1].tankDescription + '\n'
      }
      fileContent += this.$t('Date') + sep
      fileContent += (this.filters.fromDay !== undefined ? this.filters.fromDay : '') + '\n'
      fileContent += '\n'

      for (let index = 0; index < this.headers.length; index++) {
        fileContent += this.headers[index].text + sep
      }
      fileContent += '\n'

      for (let index = 0; index < this.dataSource.length; index++) {
        let t = this.dataSource[index]
        fileContent += this.getTankList(t.fuelingPosition, t.meterID) + sep
        fileContent += t.fuelingPosition + sep
        fileContent += t.meterID + sep
        fileContent += this.getTime(t.timeB) + sep
        fileContent += this.getTime(t.timeC) + sep
        fileContent += this.getDuration(t.timeB, t.timeC) + sep
        fileContent += this.Maglink.VolumeFormat(t.transactionVolume, this.systemSettings.volumeUnit) + sep
        fileContent += (t.complete ? this.$t('Complete') : this.$t('InProgress')) + '\n'
      }

      let filename = this.$t('Sales report') + '__' + title
      filename += '__' + (this.filters.fromDay !== undefined ? this.filters.fromDay : '')
      filename += '.csv'

      const link = this.Maglink.GetDownloadLinkCSV(fileContent, filename)
      document.body.appendChild(link)
      link.click()
    },
    dateFromToday (days) {
      var currentDate = new Date()
      currentDate.setDate(currentDate.getDate() + days)

      return currentDate
    },
    getDateLabel (value) {
      return this.$t(value) + ' (' + this.systemSettings.dateFormat + ')'
    },
    loadDispenserList () {
      this.dispenserList = {}

      for (let index = 0; index < this.siteMapping.dispensers.length; index++) {
        let dispenser = this.siteMapping.dispensers[index]
        var nozzleList = {}

        for (let nozzIndex = 0; nozzIndex < dispenser.nozzles.length; nozzIndex++) {
          let nozzle = dispenser.nozzles[nozzIndex]

          let tankList = []
          if (nozzle.enabled && nozzle.tankNumber1 !== 0) {
            tankList.push(nozzle.tankNumber1)
          }
          if (nozzle.enabled && nozzle.tankNumber2 !== 0) {
            tankList.push(nozzle.tankNumber2)
          }
          nozzleList[nozzle.nozzleId] = tankList
        }
        this.dispenserList[dispenser.dispenserId] = nozzleList
      }
    },
    getTankList (dispId, nozzleId) {
      if (this.dispenserList[dispId] !== undefined && this.dispenserList[dispId][nozzleId] !== undefined) {
        return this.dispenserList[dispId][nozzleId].join('-')
      }
      return ''
    },
    isTankInList (dispId, nozzleId, tankId) {
      if (this.dispenserList[dispId] !== undefined && this.dispenserList[dispId][nozzleId] !== undefined) {
        return this.dispenserList[dispId][nozzleId].includes(tankId)
      }
      return false
    },
    getDataSource () {
      this.progressBar.loading = true
      this.dataSource = []

      this.Maglink.GetReportSales(this.filters)
        .then(response => {
          this.progressBar.maxValue = response.data.length

          for (var i = 0; i < response.data.length; i++) {
            this.progressBar.currentValue = i
            let item = response.data[i]

            if (!this.filters.all && !this.isTankInList(item.fuelingPosition, item.meterID, this.filters.number)) {
              continue
            }

            this.dataSource.push(this.Maglink.ToDisplay(item, this.systemSettings.levelUnit, this.systemSettings.volumeUnit))
          }
          this.progressBar.loading = false
          this.itemCountLabel = this.$t('Items: {0}', [ this.dataSource.length ])
        })
        .catch(error => {
          this.progressBar.loading = false
          this.snack('error', error.message)
        })
    },
    getTime (value) {
      let dt = this.Maglink.GetCustomDateTime(value, this.systemSettings.dateFormat)
      let newValue = dt.split(' ')[1]

      return newValue
    },
    getDuration (initial, final) {
      let timeDiff = this.Maglink.GetTimeDiffInSeconds(initial, final)
      return this.Maglink.RoundFormat(timeDiff, 0)
    },
    onCheckDates () {
      return true
    },
    onGetDate (componentKey, day) {
      this.filters.fromDay = day
    },
    snack (color, message) {
      message = this.$t('Sales') + ': ' + message
      this.$store.dispatch('showSnackbar', { color, message, show: true })
    }
  }
}
</script>
